/**
 * Horizontal bar chart of active-vocab POS distribution. A donut would
 * look pretty but bars are easier to read and rank — the learner wants
 * to see "I have 45 nouns, 22 verbs, only 3 adjectives" quickly.
 */
const COLORS = [
  "#a25618", "#3f6a44", "#b9523a", "#c88649",
  "#7b9458", "#6d6a63", "#3a1a03", "#8a6d3b",
  "#9a968d",
];

export default function PosDistribution({
  distribution,
}: {
  distribution: Record<string, number>;
}) {
  const entries = Object.entries(distribution || {})
    .filter(([, n]) => n > 0)
    .sort((a, b) => b[1] - a[1]);
  const total = entries.reduce((s, [, n]) => s + n, 0);
  if (total === 0) {
    return (
      <div className="card">
        <div className="mb-2">
          <div className="text-xs text-ink-faint uppercase tracking-[0.14em]">
            active vocab by part of speech
          </div>
        </div>
        <div className="text-ink-faint text-sm py-4 text-center">
          no active words yet
        </div>
      </div>
    );
  }
  const max = entries[0][1];

  return (
    <div className="card">
      <div className="mb-3">
        <div className="text-xs text-ink-faint uppercase tracking-[0.14em]">
          active vocab by part of speech
        </div>
        <div className="text-[11px] text-ink-faint mt-0.5">
          what kinds of words you've mastered
        </div>
      </div>
      <div className="space-y-2">
        {entries.map(([label, n], i) => {
          const pct = (n / max) * 100;
          const totalPct = (n / total) * 100;
          return (
            <div key={label} className="flex items-center gap-3 text-xs">
              <span className="w-24 shrink-0 text-ink-soft">{label}</span>
              <div className="flex-1 h-4 bg-ink-faint/10 rounded-sm relative overflow-hidden">
                <div
                  className="h-full rounded-sm"
                  style={{
                    width: `${Math.max(2, pct)}%`,
                    background: COLORS[i % COLORS.length],
                  }}
                />
              </div>
              <span className="w-16 shrink-0 text-right text-ink font-medium">
                {n}
                <span className="text-ink-faint ml-1 text-[10px]">
                  {totalPct.toFixed(0)}%
                </span>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
